import { CompatNativeSafeAreaProvider } from './CompatNativeSafeAreaProvider';

export default CompatNativeSafeAreaProvider;
